import React from 'react'
import { motion } from "framer-motion";
import introthum from '../introImg.jpeg'
import { Link } from 'react-router-dom';


export default function Intro() {
  return (
    <section className="bg-gray-100 py-20 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

        {/* Left Image */}
        <motion.div
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="relative"
        >
          <img
            src={introthum}
            alt="About"
            className="rounded-2xl w-full h-auto object-cover"
          />

          {/* Badge */}
          {/* <div className="absolute bottom-5 left-5 bg-[#0fce84] text-white px-6 py-4 rounded-xl shadow-lg">
                 <h2 className="text-2xl font-bold">5+</h2>
                 <p className="text-xs uppercase">Years of Excellence</p>
               </div> */}
        </motion.div>

        {/* Right Content */}
        <motion.div
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <p className=" uppercase font-semibold text-lg mb-2 " style={{ color: '#0fce84 ' }}>
            About LNVS Fintech
          </p>

          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
            Advancing the Future of Digital Lending
          </h2>

          <p className="text-gray-600 mb-4 leading-7">
            At LNVS FINTECH PRIVATE LIMITED, we started with a simple belief - financial services should work for businesses, not against them. We're a fintech company built to make digital lending faster, safer, and genuinely easier for the businesses that depend on it.
          </p>

          <p className="text-gray-600 mb-6 leading-7">
           From KYC verification to payment solutions and lending platforms, we've put everything under one roof - so you're not juggling five different tools to get one thing done. Our APIs are built to grow with you, whether you're processing your first loan or your ten-thousandth.</p>

          <p className="text-gray-600 mb-6 leading-7">We won't pretend the gap between traditional finance and modern technology is small - but closing it is exactly what we do every day. No unnecessary complexity, no slow approvals, no friction.</p>
             <p className="text-gray-600 mb-6 leading-7">Just reliable technology backed by people who actually care about where your business is headed.</p>


          {/* Vision & Mission */}
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
   
                 <div>
                   <h3 className="font-semibold text-lg text-gray-900 mb-1">
                     Our Vision
                   </h3>
                   <p className="text-sm text-gray-600">
                     To simplify and scale lending through automation and secure infrastructure. We help institutions deliver faster, efficient credit experiences with minimal intervention.
                   </p>
                 </div>
   
                 <div>
                   <h3 className="font-semibold text-lg text-gray-900 mb-1">
                     Our Mission
                   </h3>
                   <p className="text-sm text-gray-600">
                     Delivering robust, secure, and future-ready IT infrastructure.
                   </p>
                 </div>
   
               </div> */}

          {/* CTA */}
          {/* <Link to={'/aboutus'}>
            <button className="flex items-center gap-2 text-[#0fce84] font-medium hover:gap-3 transition">
              Read Our Story →
            </button>
          </Link> */}
        </motion.div>

      </div>
    </section>
  )
}
